<template>
    <base-spinner :open="isloading"></base-spinner>
    <div class="compare card">                        
        <div class="table-responsive">
            <table class="compare__table compare-table">
                <tbody>
                    <!-- first row -->
                    <tr class="compare-table__row">
                        <th class="compare-table__column compare-table__column--header">Product</th>
                        <!-- <td class="compare-table__column compare-table__column--product compare-table__column--product-selected-bg"> -->
                        <compare-img-item 
                            v-for="product in products" 
                            :key="product.ID"
                            :item="product.ID"
                            :description="product.description"
                            :image="product.image"
                            :url="/part/ + product.manufacturer + '/'+ product.ID + '/' + product.mfgSeo + '/' + product.itemSeo"
                            :isSelected="product.isSelected"
                            >
                        </compare-img-item>
                    </tr>
                    <!-- end first row-->

                    <!-- 2nd row prices -->
                    <tr class="compare-table__row">
                        <th class="compare-table__column compare-table__column--header">Price</th>
                        <compare-price-item
                            v-for="product in products"
                            :key="product.ID"
                            :price="product.yourprice">
                        </compare-price-item>
                    </tr>
                    <!-- end 2nd row -->

                    <!-- 3nd row core charge prices -->
                    <tr class="compare-table__row">
                        <th class="compare-table__column compare-table__column--header">Core Charge</th>
                        <compare-price-item
                            v-for="product in products"
                            :key="product.ID"
                            :price="product.corecharge">
                        </compare-price-item>
                    </tr>

                    <!-- 4th row location 1 -->
                    <tr class="compare-table__row" v-for="(loc, index) in prodDefaultLocs" :key="index">
                        <th class="compare-table__column compare-table__column--header-vertical-top">{{loc.location}}</th>
                        <!-- <td class="compare-table__column--product-left"> -->
                        <compare-loc-item 
                            v-for="product in products"
                            :key="product.ID"
                            :location="getProdLoc(product.ID, product.manufacturer)"
                            :location_id="loc.location_id"
                            :product="product"
                            >
                        </compare-loc-item>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <base-dialog
        title="Confirm Delete"
        @close="cancelRemove"
        :open="selectedProductIndx != null"
    >
        <template #default>
        <p>Are you sure you want to remove this product?</p>
        </template>
        <template #actions>
        <button
            type="button"
            class="btn btn-sm btn-secondary mr-2"
            @click="cancelRemove"
        >
            Cancel
        </button>
        <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="confirmRemove"
        >
            Ok
        </button>
        </template>
    </base-dialog>
</template>

<style scoped>
    .compare-table__column--product-left{
        border-left: 1px solid #ebebeb;
        border-right: 1px solid #ebebeb;
    }
</style>

<script>
import CompareLocItem from './CompareLocItem.vue';
import CompareImgItem from './CompareImgItem.vue';
import ComparePriceItem from './ComparePriceItem.vue';
import axiosvl from "../../../axios/axios-vl.js";
import CloudinaryApi from '../../../utilities/cloudinaryapi';
import * as GCONST from '../../../constants.js';
import { mapGetters } from 'vuex';

export default {
    components: { CompareLocItem, CompareImgItem, ComparePriceItem },
    data() {
        return {
            selectedProductIndx : null,
            prodDefaultLocs: [],
            products: [],
            prodLocs:[],
        }
    },

    computed: {
        ...mapGetters([
            'storefrontAttributes',
            'custB2BLocations',
            'customerIndicator'
        ]),
    },

    methods : {
        removeColumn(index) {
            this.selectedProductIndx = index;
        },
        confirmRemove() {
            this.products.splice(this.selectedProductIndx, 1);
            this.selectedProductIndx = null;
        },
        cancelRemove() {
            this.selectedProductIndx = null;
        },

        /**
         * get locations of selected product item
         * then get the substitutes items of the selected product
         */
        prodSelectedLocs() {
            if (this.customerIndicator == 'B'){
                this.stockCheck(this.$route.params.manufacturer, this.$route.params.partnumber, true).then(locs => {
                    this.prodDefaultLocs = locs;

                    this.getSubstitutes();
                });
            }else{
                this.getSubstitutes();
            }
        },

        getSubstitutes(){
            this.isloading = true;

            axiosvl.post(this.$store.getters['api/substitute_parts_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                        "EIMFGC": { "value": this.$route.params.manufacturer },
                        "EIITMC": { "value": this.$route.params.partnumber },
                    },   
                }
            })
            .then((response) => {
                const CPARTS = response.data.webroutine.lists.CPARTS.entries;
                const wd_mdfgs = this.$store.getters.wd_mfgs;

                for (const key in CPARTS) {
                    const obj = CPARTS[key];
                    const clApi = new CloudinaryApi;
                    const clearProductDesc = encodeURIComponent(obj.IMDESC);

                    clApi.item_sku = obj.DMITMC;
                    clApi.manufacturer_code = obj.IUUMFG;
                    
                    clApi.vlImageByMeta(GCONST.CL_META_ITEM_SKU, GCONST.Product_Thumbnail).then(imgURL => {
                        let image;
                        if(imgURL){
                            image = imgURL;
                        }else{
                            image = GCONST.IMAGE_PLACEHOLDER;
                        }

                        this.products.push({
                            ID            : obj.DMITMC,
                            name          : obj.IMDESC,
                            description   : obj.IMDESC,
                            quantity      : 1,
                            image         : image,
                            isSelected    : false,
                            avail_locs    : null,

                            mfgSeo        : wd_mdfgs.find(w => w.MFG_CODE == obj.IUUMFG).SEO,
                            itemSeo       : clearProductDesc.replace(/ /g, "-"),

                            manufacturer    : obj.IUUMFG,
                            listprice       : obj.EILSTP,
                            corecharge      : obj.CORP,
                            yourprice       : obj.PRC,
                            
                            XRMFGC          : obj.XRMFGC,
                            XRITMC          : obj.XRITMC,
                            IMIGSA          : obj.IMIGSA,
                            IMISVALID       : obj.IMISVALID,
                        });

                        if (this.customerIndicator == 'B'){
                            setTimeout(() => {
                                this.isloading = true;
                                this.stockCheck(obj.IUUMFG, obj.DMITMC).then(res => {
                                    this.prodLocs.push({
                                        ITEM: obj.DMITMC,
                                        MFGC: obj.IUUMFG,
                                        locations: res
                                    })
                                    // this.products[i].avail_locs = res;
                                    this.isloading = false;
                                });
                            }, 500);
                        }else{
                            this.isloading = false;
                        }
                        
                    });
                }
                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        stockCheck(manufacturer, partnumber) {
            this.locations = [];
            this.isloading = true;
            return axiosvl.post(this.$store.getters['api/stock_check'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer },
                        "EIMFGC": {"value": manufacturer },
                        "EIITMC": {"value": partnumber },
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields
                const SCLOC = response.data.webroutine.lists.SCLOC.entries;
                const locations = [];
                if (fields.RESULTCOD.value === 'OK') {
                    // locations
                    for (const key in SCLOC) {
                        const obj = SCLOC[key];
                        // get the sequence from cust locations of each location got from the product
                        const sequence = this.custB2BLocations.find(loc => loc.LCLOC === obj.ILLOC);
                        
                        locations.push({
                            sku     : partnumber,
                            city    : obj.ADCITY,
                            state   : obj.ADSTTC,
                            itemnumber : obj.EIITMC,
                            manufacturer : obj.EIMFGC,
                            location_id : obj.ILLOC,
                            location : obj.LCNAME,
                            tax_city : obj.LCTAXC,
                            stockquantity : obj.LOCOH,
                            stock : obj.QOSTK,
                            eta_day : obj.QTETAD,
                            eta_mo : obj.QTETAM,
                            eta_yr : obj.QTETAY,
                            on_order : obj.QTONOR,
                            rank : obj.QTRANK,
                            STOCKEDIL : obj.STOCKEDIL,
                            quantity : 1,
                            sequence : sequence.O9SQLO,

                            XRMFGC: obj.XRMFGC,
                            XRITMC: obj.XRITMC,
                            IMIGSA: obj.IMIGSA,
                            IMISVALID: obj.IMISVALID,
                        });

                        // sort the locations by sequence
                        locations.sort((a,b) => (a.sequence > b.sequence) ? 1 : ((b.sequence > a.sequence) ? -1 : 0));
                    }
                    return locations;
                    
                } else {
                    const messages = [];
                    const wrmessages = response.data.webroutine.messages;

                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }

                    this.$emit('show_messages', messages);
                }
                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        getProductDetails() {
            // console.log('called getProductDetails');
            this.isloading = true;

            return axiosvl.post(this.$store.getters['api/product_details_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                        "EIMFGC": { "value": this.$route.params.manufacturer },
                        "EIITMC": { "value": this.$route.params.partnumber },
                    },   
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;
                
                const clearProductDesc = encodeURIComponent(fields.IMDESC.value);
                
                // get cloudinary image
                const clApi = new CloudinaryApi;
                clApi.item_sku = fields.IMITMC.value;
                clApi.manufacturer_code = fields.IMMFGC.value;

                clApi.vlImageByMeta(GCONST.CL_META_ITEM_SKU, GCONST.Product_Thumbnail).then(imgURL => {
                        let image;
                        if(imgURL){
                            image = imgURL;
                        }else{
                            image = GCONST.IMAGE_PLACEHOLDER;
                        }
                        // const key = 0;
                        this.products.push({
                            ID            : fields.IMITMC.value,
                            name          : fields.IMDESC.value,
                            description   : fields.IMDESC.value,
                            quantity      : 1,
                            image         : image,
                            isSelected    : true,
                            avail_locs    : null,

                            mfgSeo        : fields.MCNAME.value.replace(/ /g, "-"),
                            itemSeo       : clearProductDesc.replace(/ /g, "-"),

                            manufacturer    : fields.IMMFGC.value,
                            listprice       : fields.EILSTP.value,
                            corecharge      : fields.EICORP.value,
                            yourprice       : fields.EIEXCP.value,
                            
                            XRMFGC          : fields.XRMFGC.value,
                            XRITMC          : fields.XRITMC.value,
                            IMIGSA          : fields.IMIGSA.value,
                            IMISVALID       : fields.IMISVALID.value,
                        });

                        if (this.customerIndicator == 'B'){
                            // setTimeout(() => {
                            //     this.isloading = true;
                            //     this.stockCheck(fields.IMMFGC.value, fields.IMITMC.value).then(res => {
                            //         this.products[key].avail_locs = res;
                            //         console.log(this.products[key]);
                            //         this.isloading = false;
                            //     });
                            // }, 500);
                            setTimeout(() => {
                                this.isloading = true;
                                this.stockCheck(fields.IMMFGC.value, fields.IMITMC.value).then(res => {
                                    this.prodLocs.push({
                                        ITEM: fields.IMITMC.value,
                                        MFGC: fields.IMMFGC.value,
                                        locations: res
                                    })
                                    // this.products[i].avail_locs = res;
                                    this.isloading = false;
                                });
                            }, 500);
                        }else{
                            this.isloading = false;
                        }
                        
                });

                

                this.isloading = false;
                return true;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        getProdLoc(item, mfgc){
            const prLoc = this.prodLocs.find(p => (p.ITEM == item && p.MFGC == mfgc));
            if(prLoc)
                return prLoc.locations;

            return null;
        }
    },
    created() {

        this.getProductDetails().then(() => {
           this.prodSelectedLocs();
        });
    }
}
</script>